import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { db, auth } from './firebase';

export default function AgentPanel() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  const loadBookings = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, 'bookings'));
      const data = [];
      snap.forEach((d) => data.push({ id: d.id, ...d.data() }));
      const pending = data.filter((b) => {
        const s = b.orderStatus || 'booked';
        return s === 'booked' || s === 'out_for_delivery';
      });
      pending.sort((a, b) => {
        const at = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : 0;
        const bt = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : 0;
        return bt - at;
      });
      setBookings(pending);
    } catch (e) {
      console.error('Error loading bookings:', e);
    }
    setLoading(false);
  };

  useEffect(() => { if (isLoggedIn) loadBookings(); }, [isLoggedIn]);

  const handleLogin = async () => {
    setLoginError('');
    if (!email || !password) { setLoginError('Please enter email and password.'); return; }
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setIsLoggedIn(true);
      setEmail(''); setPassword('');
    } catch (e) {
      setLoginError('Wrong email or password.');
    }
  };

  const handleLogout = async () => {
    try { await signOut(auth); } catch (e) {}
    setIsLoggedIn(false);
    setBookings([]);
  };

  const markDelivered = async (id) => {
    if (!window.confirm('Mark this order as DELIVERED and start the customer trial?')) return;
    setUpdatingId(id);
    try {
      await updateDoc(doc(db, 'bookings', id), { orderStatus: 'in_trial' });
      await loadBookings();
    } catch (e) {
      alert('Could not update. Please try again.');
    }
    setUpdatingId(null);
  };

  const inputStyle = { width: '100%', padding: '14px', marginBottom: '16px', borderRadius: '12px', border: '1px solid #ddd', fontSize: '16px', boxSizing: 'border-box' };

  if (!isLoggedIn) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f5f5f5', padding: '20px', fontFamily: 'Arial' }}>
        <div style={{ width: '100%', maxWidth: '400px', background: 'white', borderRadius: '24px', padding: '38px 32px' }}>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '30px', color: '#111', margin: '0 0 6px', textAlign: 'center', letterSpacing: '5px' }}>FIVETRY</h1>
          <p style={{ fontSize: '12px', color: '#888', textAlign: 'center', marginBottom: '28px', letterSpacing: '2px' }}>DELIVERY AGENT LOGIN</p>
          <input type="email" placeholder="Agent Email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleLogin(); }} style={inputStyle} />
          {loginError && <p style={{ color: '#dc2626', fontSize: '14px', fontWeight: '600', marginTop: '-6px', marginBottom: '14px' }}>{loginError}</p>}
          <button onClick={handleLogin} style={{ width: '100%', background: '#111', color: 'white', border: 'none', padding: '15px', borderRadius: '14px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>Login</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', fontFamily: 'Arial' }}>
      <div style={{ background: '#111', color: 'white', padding: '18px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontFamily: 'Georgia, serif', fontSize: '18px', letterSpacing: '4px' }}>FIVETRY</div>
          <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#b89968', marginTop: '2px' }}>DELIVERY PANEL</div>
        </div>
        <button onClick={handleLogout} style={{ border: 'none', background: '#9c7d4f', color: 'white', padding: '9px 16px', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>Logout</button>
      </div>

      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '22px 16px 60px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
          <h2 style={{ color: '#111', margin: 0, fontSize: '18px' }}>Pending Deliveries ({bookings.length})</h2>
          <button onClick={loadBookings} style={{ border: '1px solid #ccc', background: 'white', color: '#111', padding: '7px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>↻ Refresh</button>
        </div>

        {loading ? (
          <p style={{ color: '#666' }}>Loading…</p>
        ) : bookings.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center', padding: '40px 0' }}>No pending deliveries right now. 🎉</p>
        ) : (
          bookings.map((b) => (
            <div key={b.id} style={{ background: 'white', borderRadius: '16px', padding: '18px', marginBottom: '16px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <span style={{ fontWeight: '700', color: '#16a34a', fontSize: '15px' }}>{b.bookingId}</span>
                <span style={{ fontSize: '11px', color: '#888' }}>{b.itemsSelected} items</span>
              </div>
              <p style={{ margin: '4px 0', fontSize: '14px' }}><strong>{b.customerName}</strong></p>
              <p style={{ margin: '4px 0', fontSize: '14px', color: '#444' }}>{b.customerAddress}</p>
              <p style={{ margin: '4px 0', fontSize: '13px', color: '#666' }}>{b.deliveryDay} · {b.timeSlot}</p>
              <a href={'tel:' + b.customerPhone} style={{ display: 'inline-block', margin: '6px 0 12px', fontSize: '14px', color: '#1d4ed8', textDecoration: 'none', fontWeight: '600' }}>📞 {b.customerPhone}</a>

              {Array.isArray(b.selectedItems) && b.selectedItems.length > 0 && (
                <div style={{ background: '#fafaf7', border: '1px solid #eeeae3', borderRadius: '10px', padding: '10px 12px', marginBottom: '14px' }}>
                  {b.selectedItems.map((it, i) => (
                    <div key={i} style={{ fontSize: '13px', color: '#333', padding: '3px 0' }}>
                      {typeof it === 'string' ? it : <>{it.name} {it.size && it.size !== 'Not specified' && <strong style={{ color: '#9c7d4f' }}>· {it.size}</strong>}</>}
                    </div>
                  ))}
                </div>
              )}

              <button onClick={() => markDelivered(b.id)} disabled={updatingId === b.id} style={{ width: '100%', background: updatingId === b.id ? '#888' : '#16a34a', color: 'white', border: 'none', padding: '14px', borderRadius: '12px', fontSize: '14px', fontWeight: '700', letterSpacing: '1px', cursor: updatingId === b.id ? 'not-allowed' : 'pointer' }}>
                {updatingId === b.id ? 'UPDATING…' : 'MARK DELIVERED · START TRIAL'}
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}